import { styled } from '@mui/material/styles';
import { Box, Typography, Button, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import FingerprintIcon from '@mui/icons-material/Fingerprint';

export const StyledDialogTitle = styled(DialogTitle)({
  textAlign: 'center',
  paddingBottom: '8px',
});

export const StyledDialogContent = styled(DialogContent)({
  paddingLeft: '24px',
  paddingRight: '24px',
});

export const StyledDialogActions = styled(DialogActions)({
  paddingLeft: '24px',
  paddingRight: '24px',
  paddingBottom: '16px',
  paddingTop: '8px',
});

export const DialogContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '8px 0',
});

export const IconWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '16px',
});

export const SuccessIconWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '24px',
  marginTop: '16px',
});

export const SuccessTitle = styled(Typography)({
  fontSize: '18px',
  fontWeight: 600,
  color: '#000',
  textAlign: 'center',
  marginBottom: '16px',
});

export const TitleText = styled(Typography)({
  fontSize: '18px',
  fontWeight: 600,
  color: '#000',
});

export const MessageText = styled(Typography)({
  fontSize: '14px',
  color: '#535353',
  textAlign: 'center',
  marginBottom: '12px',
  lineHeight: 1.5,
});

export const AlertWrapper = styled(Box)({
  width: '100%',
  marginBottom: '16px',
});

export const StyledFingerprintIcon = styled(FingerprintIcon)({
  fontSize: '48px',
  color: '#ff4c00',
});

export const StyledConfirmButton = styled(Button)({
  '&:hover': {
    backgroundColor: '#395bbd !important',
  },
  fontSize: '13px',
  textTransform: 'none',
  backgroundColor: '#395bbd',
  borderRadius: '8px',
  boxShadow: 'none !important',
  fontWeight: '600',
});

export const StyledCancelButton = styled(Button)({
  '&:hover': {
    backgroundColor: '#e0e0e0',
  },
  fontSize: '13px',
  textTransform: 'none',
  borderRadius: '8px',
  fontWeight: '600',
  color: '#395bbd',
});

export const OptionContainer = styled(Box)(({ theme, selected }) => ({
  border: `1px solid ${selected ? theme.palette.primary.main : theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1),
  marginBottom: theme.spacing(1),
  backgroundColor: selected ? theme.palette.action.selected : 'transparent',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const OptionContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
});

export const OptionTitle = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontWeight: 600,
  fontSize: '14px',
  marginBottom: theme.spacing(0.5),
}));

export const OptionDescription = styled(Box)(({ theme }) => ({
  fontSize: '13px',
  color: theme.palette.text.secondary,
  lineHeight: 1.4,
  textAlign: 'left',
}));
